import { Option } from "../services/db";

const getValueOfStoredOption = (options: Option[] | undefined, searchName: string) => {
	return options?.find((optionName) => optionName.name === searchName)?.value || "";
};

export default getValueOfStoredOption;
